/* eslint-disable camelcase */
import React from 'react';

import Tooltip from '../../Core/Tooltip';
import Label from '../../Core/InputLabel';
import Checkbox from '../../Core/Checkbox/Checkbox2';
import Switch from 'react-switch';

const getTimeFromMinutes = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return { hours, minutes: remainingMinutes };
}

export default ({
  t,
  style,
  handleInputChange,
  timeSheetData,
  AdditionalRates,
  journal
}) => {
  const {hours, minutes} = getTimeFromMinutes(timeSheetData.overtime_indicator_limit || 0);
  const handleChangeInput = (name) => (e) => {
    const { value } = e.target;
    let newValue = value.replace(/\D/g, ''); // Remove non-numeric characters
    if (name === 'hours') {
      if (newValue.length > 2) newValue = newValue.slice(0, 2); // Limit to 2 digits
      const totalMinutes = parseInt(newValue || 0, 10) * 60 + parseInt(minutes || 0, 10);
      handleInputChange({ target: { name: 'overtime_indicator_limit', value: totalMinutes } });
    } else if (name === 'minutes') {
      if (newValue.length > 2) newValue = newValue.slice(0, 2); // Limit to 2 digits
      const totalMinutes = parseInt(hours || 0, 10) * 60 + parseInt(newValue || 0, 10);
      handleInputChange({ target: { name: 'overtime_indicator_limit', value: totalMinutes } });
    }
  }

  return (
    <div className={style.timeSheetBlock}>

    <div className={style.generalBlock2}>
      <Switch
        onChange={(checked) => { handleInputChange({ target: { name: 'use_accumulated', value: checked, type : 'checkbox' }}) }}
        offColor='#808F94'
        onColor='#0085FF'
        uncheckedIcon={false}
        checkedIcon={false}
        checked={timeSheetData.use_accumulated || false}
        height={21}
        width={40}
      />
      <Label text={t('Use accumulated hours calculation')} />
    </div>

    <div className={style.generalBlock2}>
      <Switch
        onChange={(checked) => { handleInputChange({ target: { name: 'merge_timesheet_places', value: checked, type : 'checkbox' }}) }}
        offColor='#808F94'
        onColor='#0085FF'
        uncheckedIcon={false}
        checkedIcon={false}
        checked={timeSheetData.merge_timesheet_places || false}
        height={21}
        width={40}
      />
      <Label text={t("Don't split worktime by place")} />
    </div>

    <div className={style.generalBlock2}>
      <Switch
        onChange={(checked) => { handleInputChange({ target: { name: 'show_overtime_indicator', value: checked, type : 'checkbox' }}) }}
        offColor='#808F94'
        onColor='#0085FF'
        uncheckedIcon={false}
        checkedIcon={false}
        checked={timeSheetData.show_overtime_indicator || false}
        height={21}
        width={40}
      />
      <Label text={t("Indicate total work over")} />
      <div className={style.inputBlock} style={{opacity: timeSheetData.show_overtime_indicator ? 1 : 0.5}}>
        <input type="text" className={style.input} readOnly={!timeSheetData.show_overtime_indicator} value={hours} onChange={handleChangeInput('hours')} />
        <span>:</span>
        <input type="text" className={style.input} readOnly={!timeSheetData.show_overtime_indicator} value={minutes} onChange={handleChangeInput('minutes')} />
      </div>
      <Tooltip title={t('This will show warning filter in the Timesheet module on those entries which are over the selected total work indicator.')} />
    </div>

    <div className={style.hr} />
    
    <div className={style.timeSheet__label}>
      <Label text={`${t('Select hours types to show in Time Sheet')}`} />
      <Tooltip title={t('Selecting or deselecting the value will control the data you would like to see in the Time Sheet for all users who are using this module. If deselected - such data row will be excluded from the module.')} />
    </div>

    <div className={style.generalBlock}>
      <Checkbox
        onChange={handleInputChange}
        checked={timeSheetData.total_hours}
        label={t('Total Hours')}
        name='total_hours'
      />
    </div>

    <div className={style.generalBlock}>
      <Checkbox
        onChange={handleInputChange}
        checked={timeSheetData.working_time}
        label={t('Working Time')}
        name='working_time'
      />
    </div>

    <div className={style.generalBlock}>
      <Checkbox
        onChange={handleInputChange}
        checked={timeSheetData.worked_hours}
        label={t('Regular Hours')}
        name='worked_hours'
      />
    </div>

    <div className={style.generalBlock}>
      <Checkbox
        onChange={handleInputChange}
        checked={timeSheetData.break_hours}
        label={t('Break Hours')}
        name='break_hours'
      />
    </div>
    {
      (AdditionalRates.night_time) && (
        <div className={style.generalBlock}>
          <Checkbox
            onChange={handleInputChange}
            checked={timeSheetData.night_hours}
            label={t('Night Work Hours')}
            name='night_hours'
          />
        </div>
      )
    }
    {
      (AdditionalRates.holiday) && (
        <div className={style.generalBlock}>
          <Checkbox
            onChange={handleInputChange}
            checked={timeSheetData.holiday_hours}
            label={t('Work on Bank Holiday Hours')}
            name='holiday_hours'
          />
        </div>
      )
    }

    <div className={style.generalBlock}>
      <Checkbox
        onChange={handleInputChange}
        checked={timeSheetData.overtime_hours}
        label={t('Overtime Hours')}
        name='overtime_hours'
      />
    </div>

    <Label text={`${t('Select which calculation to show in Time Sheet')}`} />

    <div className={style.generalBlock}>
      <Checkbox
        onChange={handleInputChange}
        checked={timeSheetData.show_costs}
        label={t('Show Costs')}
        name='show_costs'
      />
    </div>

    {
      journal.additional_bonus
        ? <div className={style.generalBlock}>
            <Checkbox
              onChange={handleInputChange}
              checked={timeSheetData.show_bonus}
              label={t('Show Bonus')}
              name='show_bonus'
            />
          </div>
        : null
    }

    <Label text={`${t('Select day types to show for Time Sheet')}`} />

    <div className={style.generalBlock}>
      <Checkbox
        onChange={handleInputChange}
        checked={timeSheetData.working_days}
        label={t('Working Days')}
        name='working_days'
      />
    </div>

  </div>
  )
};
